import { render, staticRenderFns } from "./GlobalNotificationBar.vue?vue&type=template&id=9b349f9e&scoped=true"
import script from "./GlobalNotificationBar.vue?vue&type=script&lang=ts"
export * from "./GlobalNotificationBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b349f9e",
  null
  
)

export default component.exports